import { render } from "./BugFill.vue?vue&type=template&id=3cbac6cf"
const script = {}

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c888307087c990cfda5c0d18ef320e2e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/icons/BugFill.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3cbac6cf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3cbac6cf', __exports__)) {
    api.reload('3cbac6cf', __exports__)
  }
  
  module.hot.accept("./BugFill.vue?vue&type=template&id=3cbac6cf", () => {
    api.rerender('3cbac6cf', render)
  })

}


export default __exports__